import React from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

export const DockTrigger = ({ onClick }) => (
  <motion.button
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.6 }}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={onClick}
    className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 pl-3 pr-4 py-3 rounded-full bg-gradient-to-br from-purple-600 to-pink-600 shadow-2xl shadow-purple-500/40 hover:shadow-purple-500/60 transition-shadow"
    data-testid="floating-officer-dock-trigger"
    aria-label="AI Officers"
  >
    <span className="relative flex items-center justify-center w-7 h-7 rounded-full bg-white/15">
      <Sparkles className="w-4 h-4 text-white" />
      <span className="absolute inset-0 rounded-full bg-white/20 animate-ping" style={{ animationDuration: "2.5s" }}></span>
    </span>
    <span className="text-[12px] font-semibold text-white whitespace-nowrap leading-none">AI Officers</span>
    <span className="absolute -top-1 -right-1 w-3 h-3 bg-emerald-400 rounded-full border-2 border-[#0A0A0F]"></span>
  </motion.button>
);
